// src/config.js

const config = {
    apiBaseUrl: 'http://desktop-52n9ufi/ssm/api'
  };
  
  export default config;
  